if (!customElements.get("facet-filters")) {
  class e extends SideDrawer {
    constructor() {
      if (
        (super(),
        (this.filteringEnabled = "true" === this.dataset.filtering),
        (this.sortingEnabled = "true" === this.dataset.sorting),
        (this.results = document.getElementById("filter-results")),
        (!this.filteringEnabled && !this.sortingEnabled) || !this.results)
      )
        return;
      window.initLazyScript(this, this.init.bind(this));
    }
    init() {
      (this.resultsCountEl = document.getElementById("results-count")),
        (this.form = document.getElementById("facets")),
        this.filteringEnabled &&
          ((this.showFiltersBtn = document.querySelector(".js-show-filters")),
          (this.filters = this.querySelector(".facets__filters")),
          (this.activeFilters = document.querySelector(".active-filters")),
          (this.footer = this.querySelector(".facets__footer")),
          (this.filtersOpen = this.dataset.filtersOpen),
          this.showFiltersBtn.addEventListener(
            "click",
            this.showFilters.bind(this)
          ),
          this.filters.addEventListener(
            "click",
            this.handleFiltersClick.bind(this)
          ),
          this.filters.addEventListener(
            "input",
            window.debounce(this.handleFilterChange.bind(this), 300)
          ),
          this.activeFilters.addEventListener(
            "click",
            this.handleActiveFiltersClick.bind(this)
          )),
        this.sortingEnabled &&
          ((this.desktopSortBy = document.getElementById("sort-by")),
          this.desktopSortBy.addEventListener(
            "change",
            this.handleFilterChange.bind(this)
          )),
        window.addEventListener(
          "popstate",
          this.handleHistoryChange.bind(this)
        ),
        window.addEventListener(
          "on:debounced-resize",
          this.handleWindowResize.bind(this)
        ),
        this.handleWindowResize();
    }
    showFilters() {
      this.open(this.showFiltersBtn);
    }
    handleFilterChange(e) {
      let t = new FormData(this.form),
        s = new URLSearchParams(t),
        i = [];
      if (this.sortingEnabled) {
        if (e.target === this.desktopSortBy) {
          let r = this.querySelector(
            `#drawer-sort-by input[name="sort_by"][value="${this.desktopSortBy.value}"]`
          );
          r && (r.checked = !0);
        } else
          "sort_by" === e.target.name &&
            (this.desktopSortBy.value = e.target.value);
        s.set("sort_by", this.desktopSortBy.value);
      }
      s.forEach((e, t) => {
        e || i.push(t);
      }),
        i.forEach((e) => {
          s.delete(e);
        }),
        this.applyFilters(s.toString());
    }
    handleFiltersClick(e) {
      let { target: t } = e;
      if (
        (t.matches(".js-clear-filter") &&
          (e.preventDefault(),
          this.applyFilters(new URL(e.target.href).searchParams.toString())),
        t.matches(".js-show-more"))
      ) {
        let s = t.closest(".filter");
        t.remove(),
          s.querySelectorAll("li").forEach((e) => {
            e.classList.remove("js-hidden");
          });
      }
    }
    handleActiveFiltersClick(e) {
      "A" === e.target.tagName &&
        (e.preventDefault(),
        this.applyFilters(new URL(e.target.href).searchParams.toString()));
    }
    handleHistoryChange(e) {
      let t = "";
      e.state && e.state.searchParams && ({ searchParams: t } = e.state),
        this.applyFilters(t, !1);
    }
    handleWindowResize() {
      theme.mediaMatches.md
        ? this.querySelectorAll(".filter").forEach((e, t) => {
            ("all" === this.filtersOpen ||
              ("some" === this.filtersOpen && t < 5)) &&
              ((e.open = !0), e.classList.add("is-open"));
          })
        : this.querySelectorAll(".filter").forEach((e) => {
            (e.open = !1), e.classList.remove("is-open");
          });
    }
    async applyFilters(t, s = !0) {
      this.results.classList.add("is-loading");
      let i = await fetch(`${window.location.pathname}?${t}`);
      if (i.ok) {
        let r = document.createElement("template");
        (r.innerHTML = await i.text()),
          this.filteringEnabled && this.updateFilters(r.content),
          (this.results.innerHTML =
            r.content.getElementById("filter-results").innerHTML),
          s && e.updateURL(t);
      }
      this.results.classList.remove("is-loading");
    }
    updateFilters(e) {
      let t = document.activeElement ? document.activeElement.id : null,
        s = [];
      if (
        (this.querySelectorAll(".filter[open]").forEach((e) => s.push(e.id)),
        (this.filters.innerHTML =
          e.querySelector(".facets__filters").innerHTML),
        s.forEach((e) => {
          this.querySelectorAll(`#${CSS.escape(e)}`).forEach((e) => {
            e.open = !0;
          });
        }),
        t)
      ) {
        let i = this.filters.querySelector(`#${CSS.escape(t)}`);
        i && i.focus();
      }
      this.updateResultsTotal(e), this.updateActiveFilters(e);
      let r = e.querySelector(".facets__footer");
      this.footer.innerHTML = r.innerHTML;
    }
    updateResultsTotal(e) {
      this.resultsCountEl &&
        (this.resultsCountEl.innerHTML =
          e.querySelector("#results-count").innerHTML);
    }
    updateActiveFilters(e) {
      (this.activeFilters.innerHTML =
        e.querySelector(".active-filters").innerHTML),
        (this.activeFilters.hidden = !this.activeFilters.querySelector(
          ".active-filters__item"
        ));
    }
    static updateURL(e) {
      window.history.pushState(
        { searchParams: e },
        "",
        `${window.location.pathname}${e && "?".concat(e)}`
      );
    }
  }
  customElements.define("facet-filters", e);
}
